import React from 'react';

interface AdminConsoleHeaderProps {
  isBeta: boolean;
  showBetaButton: boolean;
  onChangeBeta: (checked: boolean) => void;
}

export const AdminConsoleHeader: React.FC<AdminConsoleHeaderProps> = ({
  isBeta,
  showBetaButton,
  onChangeBeta,
}) =>
{
  return (
    <div className="flex items-center px-6 pt-5 pb-0 flex-shrink-0">
      <div className="flex items-center gap-4">
        <div>
          <h2 className="text-[#62aacb] text-[22px] font-normal m-0 leading-tight">
            Admin Console
          </h2>
        </div>

        {showBetaButton && (
          <div className="flex items-center gap-2 ml-4">
            <span className="text-[#555] dark:text-[#a9a093] text-sm">Beta</span>
            {/* Toggle switch */}
            <button
              role="switch"
              aria-checked={isBeta}
              onClick={() => onChangeBeta(!isBeta)}
              className={`relative inline-flex h-[24px] w-[44px] items-center rounded-full transition-colors focus:outline-none ${
                isBeta ? 'bg-[#62aacb]' : 'bg-[#ccc]'
              }`}
            >
              <span
                className={`inline-block h-[20px] w-[20px] transform rounded-full bg-white shadow transition-transform ${
                  isBeta ? 'translate-x-[22px]' : 'translate-x-[2px]'
                }`}
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
